/**
 * 鉴权 API（架构 §7.1 / T09 / T10 / T01）
 *  - POST /auth/check-invite { code } -> { valid: true } | 2001/2002
 *  - POST /auth/register     { code, username, password, nickname?, avatar? } -> AuthResult
 *  - POST /auth/login        { username, password } -> AuthResult
 */
import { post } from './client';
import type { AuthResult } from '../types/models';

export async function checkInvite(code: string): Promise<{ valid: boolean }> {
  return post<{ valid: boolean }>('/auth/check-invite', { code });
}

export async function register(
  code: string,
  username: string,
  password: string,
  nickname?: string,
  avatar?: string,
): Promise<AuthResult> {
  const body: Record<string, unknown> = { code, username, password };
  if (nickname !== undefined) body.nickname = nickname;
  if (avatar !== undefined) body.avatar = avatar;
  return post<AuthResult>('/auth/register', body);
}

export async function login(username: string, password: string): Promise<AuthResult> {
  return post<AuthResult>('/auth/login', { username, password });
}
